<div class="widget-container">
  <sk-audit [domainEntityId]="groupId"></sk-audit>
</div>
